
class UseCase {

    #lowercase;
    #uppercase;
    #number;
    #ambiguous;

    constructor () {
        this.#lowercase = 'abcdefghijklmnopqrstuvwxyz';
        this.#uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        this.#number = '0123456789';
        this.#ambiguous = new Set("0O1Il5S2Z8B6G");
        Object.freeze(this);
    }

    process (length, flagLowercase, flagUppercase, flagNumber, flagAmbiguous) {
        const characters = ''
            + (flagLowercase ? this.#lowercase : '')
            + (flagUppercase ? this.#uppercase : '')
            + (flagNumber ? this.#number : '');

        const chars = flagAmbiguous
            ? [...characters].filter(c => !this.#ambiguous.has(c))
            : [...characters];

        if (chars.length === 0) {
            return '';
        }

        let result = "";

        for (let i = 0; i < length; i++) {
            result += chars[Math.floor(Math.random() * chars.length)];
        }

        return result;

    }

}

export default new UseCase ();
